<template>
  <div class="overlay" :style="{height: isShow?'100%':'0%'}">
    <div class="btn-group" :style="{display: isShow?'':'none'}">
      <div class="btn-group-item" @click="closePreview()">
        <i class="el-icon-close btn-group-item-icon-size"></i><br />
        <span class="btn-group-item-font-size">{{ $t('close') }}</span>
      </div>
      <div class="btn-group-item"
           @click="onSaveSpecialOfferButtonClick()">
        <i class="el-icon-document-checked btn-group-item-icon-size"></i><br />
        <span class="btn-group-item-font-size">{{ $t('saveSpecialOffer') }}</span>
      </div>
      <div v-if="specialOfferDetail.status === SPECIAL_OFFER_STATUS.DRAFT"
           class="btn-group-item"
           @click="onSaveDraftButtonClick()">
        <i class="el-icon-document btn-group-item-icon-size"></i><br />
        <span class="btn-group-item-font-size">{{ $t('saveDraft') }}</span>
      </div>
    </div>
    <document-container-component
      :special-offer-detail="specialOfferDetail"
      :hotel="hotel"
      :room-type-list="roomTypeList"
    ></document-container-component>
  </div>
</template>
<script>
import i18nMessages from '@/translations/SpecialOffer/components/PreviewSpecialOffer.i18n'
import DocumentContainerComponent from '../PreviewSpecialOffer/DocumentContainerComponent'
import { SPECIAL_OFFER_REF_CODE_TYPE, SPECIAL_OFFER_STATUS, STATUS } from '@/configs/constant'

export default {
  name: 'PreviewSpecialOfferComponent',
  components: {
    DocumentContainerComponent
  },
  i18n: { messages: i18nMessages },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    specialOfferDetail: {
      type: Object,
      default: () => {
        return {
          autoRefCode: STATUS.DISABLE,
          status: SPECIAL_OFFER_STATUS.DRAFT,
          refCode: '',
          refCodeSuffixType: SPECIAL_OFFER_REF_CODE_TYPE.AGENT_NAME,
          hotel: {
            id: '',
            information: {
              code: '',
              name: ''
            },
            salePerson: {
              id: '',
              title: '',
              firstName: '',
              lastName: '',
              position: '',
              email: '',
              updatedAt: ''
            }
          },
          promotion: {
            promotion: {
              id: '',
              code: '',
              detail: '',
              minNight: 0,
              maxNight: 0,
              isEnable: 0,
              updatedAt: 0,
              bookingPeriod: {
                startDate: '',
                endDate: ''
              },
              periodOfStayList: [],
              isEnableAllotment: 0,
              roomTypeList: []
            }
          },
          agentList: [],
          general: {
            startDate: '',
            endDate: '',
            issueDate: '',
            internalNote: '',
            footerMessage: '',
            bodyMessage: ''
          }
        }
      }
    },
    hotel: {
      type: Object,
      default: () => {
        return {}
      }
    },
    roomTypeList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      isShow: false,
      SPECIAL_OFFER_STATUS: SPECIAL_OFFER_STATUS
    }
  },
  watch: {
    visible: function (newValue) {
      this.isShow = newValue
    }
  },
  methods: {
    onSaveDraftButtonClick: function () {
      this.isShow = false
      this.$emit('onSaveDraft')
    },
    onSaveSpecialOfferButtonClick: function () {
      this.isShow = false
      this.$emit('onSavePublish')
    },
    closePreview: function () {
      this.isShow = false
      this.$emit('onClose')
    }
  }
}
</script>
<style scoped>
  .overlay {
    width: 100%;
    position: fixed;
    z-index: 1;
    bottom: 0;
    left: 0;
    background-color: #ffffff;
    overflow-x: hidden;
    transition: 0.5s;
    height: 0;
    min-width: 1024px;
  }

  .overlay a {
    padding: 8px;
    text-decoration: none;
    font-size: 36px;
    color: #818181;
    display: block;
    transition: 0.3s;
  }

  .overlay a:hover, .overlay a:focus {
    color: #f1f1f1;
  }

  .overlay .btn-group {
    position: fixed;
    top: 0px;
    right: 45px;
    width: 420px;
    height: 80px;
    text-align: center;
    z-index: 10;
  }
  .btn-group-item {
    float: right;
    background-color: rgba(53, 53, 53, 0.8);
    height: 70px;
    width: 80px;
    margin-left: 3px;
    color: #ffffff;
    text-align: center;
    vertical-align: bottom;
    padding-top: 10px;
    cursor: pointer;
  }

  .btn-group-item:hover {
    background-color: rgba(102, 170, 241, 0.8);
  }
  .btn-group-item-font-size {
    font-size: 9px;
    font-weight: bold;
  }
  .btn-group-item-icon-size {
    font-size: 40px;
  }

  .editor-preview .table {
    margin: 0;
  }

  .editor-preview table {
    width: 100%;
  }

  .helping-tag {
    background-color: #78C0D8;
    color: #ffffff;
    font-weight: 600;
    padding: 3px 10px;
    border-radius: 15px;
    font-size: 15px;
  }
</style>
